/* eslint-disable */
import React from 'react'
import moment from 'moment'
import jMoment from 'moment-jalaali'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import {Pagination} from 'antd'

class PlanDrivers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedDate: moment(),
      errorPlans: '',
      driverPlans: [],
      DriversCount: '',
      allPlans: [],
      aggregation: {},
      current: 1,
      pageSize: 10,
      partDriverPlans: []
    }
  }

  componentDidMount() {
    if (!cookie.load('accessToken')) {
      window.location.assign('./')
    }

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    let {driverId} = this.props.match.params

    var data = {
      planDateMin: this.epochFrom(this.state.selectedDate),
      planDateMax: this.epochTo(this.state.selectedDate),
      driverId: driverId
    }

    http
      .get(
        `${REPORT_DISPATCH.REPORT_DISPATCH_PLAN_BYDRIVER}?export=false&planDateMin=${data.planDateMin}&planDateMax=${
          data.planDateMax
        }&driverId=${data.driverId}&pageSize=10&pageNumber=1`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data));
        if (response.data.error === null) {
          this.setState({
            driverPlans: response.data.object.result,
            aggregation: response.data.object.aggregation,
            partDriverPlans: response.data.object.result.slice(0, 10),
            length: response.data.object.result.length
          })
        } else {
          // message.error(response.data.description)
          this.setState({
            driverPlans: [],
            DriversCount: 0
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  onChangePage(pageNumber) {
    // alert(pageNumber)
    this.setState({
      current: pageNumber,
      partDriverPlans: this.state.driverPlans.slice((pageNumber - 1) * 10, pageNumber * 10)
    })
  }

  epochFrom = (x) => {
    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch - 3.5 * 3600 * 1000
  }

  epochTo = (x) => {
    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    return toEpoch - 3.5 * 3600 * 1000
  }

  searchPlanList() {
    let {driverId} = this.props.match.params
    let timeDirver = document.getElementById('dateDriver').value

    if (timeDirver == 'now') {
      var data = {
        planDateMin: this.epochFrom(this.state.selectedDate),
        planDateMax: this.epochTo(this.state.selectedDate),
        driverId: driverId
      }
    } else if (timeDirver == 'past') {
      var data = {
        planDateMin: this.epochFrom('2000/01/01 00:00:00'),
        planDateMax: this.epochTo(this.state.selectedDate.subtract(1, 'days')),
        driverId: driverId
      }
    } else if (timeDirver == 'future') {
      var data = {
        planDateMin: this.epochFrom(this.state.selectedDate.add(1, 'days')),
        planDateMax: this.epochTo('2100/01/01 23:59:00'),
        driverId: driverId
      }
    }

    sessionStorage.setItem(
      'params',
      `planDateMin=${data.planDateMin}&planDateMax=${data.planDateMax}&driverId=${data.driverId}`
    )

    http
      .get(
        `${REPORT_DISPATCH.REPORT_DISPATCH_PLAN_BYDRIVER}?export=false&planDateMin=${data.planDateMin}&planDateMax=${
          data.planDateMax
        }&driverId=${data.driverId}&pageSize=10&pageNumber=1&sortBy=deliveryPlanDate_DESC`,
        {}
      )
      .then((response) => {
        console.log(response)
        if (response.data.error === null) {
          this.setState({
            driverPlans: response.data.object.result,
            DriversCount: response.data.object.countAll,
            aggregation: response.data.object.aggregation,
            partDriverPlans: response.data.object.result.slice(0, 10),
            length: response.data.object.result.length
          })
        } else {
          // message.error(response.data.description)
          this.setState({
            driverPlans: [],
            DriversCount: 0
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  onResultFetched(data) {
    this.setState({
      driverPlans: data
    })
  }

  submit(e) {
    e.preventDefault()
  }
  render() {
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let pageNumber = this.state.current

    return (
      <div className="rtl printA4Page">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>
              <Link to={'/drivers'}>رساننده ها</Link>
            </li>
            <li>پلن های رساننده {this.props.match.params.name}</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="formComponent">
              <select className="form-control" id="dateDriver" onChange={this.searchPlanList.bind(this)}>
                <option value="past">گذشته</option>
                <option value="now" selected={true}>
                  امروز
                </option>
                <option value="future">آینده</option>
              </select>
              {/*<button onClick={this.searchPlanList.bind(this)}>نمایش نتایج</button>*/}
              <p className="errorText">{this.state.errorPlans}</p>
            </div>
          </form>

          <div
            className="tableComponent"
            style={this.state.driverPlans.length == 0 ? {display: 'none'} : {display: 'block'}}
          >
            <table className="baseTable">
              <tbody>
                <tr className="firstRow">
                  <td>ردیف</td>
                  <td>تاریخ</td>
                  <td>بازه</td>
                  <td>تعداد کل</td>
                  <td>تعداد تخصیص نداده</td>
                  <td>تعداد فعال</td>
                  <td>تعداد شروع شده</td>
                  <td>تعداد تمام شده</td>
                  <td>تعداد برگشتی</td>
                  <td>تعداد مرجوعی</td>
                  <td>تعداد تخصیص مجدد</td>

                  <td>فاکتور ها</td>
                  <td>ویرایش ماشین</td>
                  <td>ویرایش فاکتور ها</td>
                </tr>
                {this.state.partDriverPlans.map((items, index) => (
                  <tr key={index}>
                    <td>{(pageNumber - 1) * 10 + index + 1}</td>
                    <td>{jMoment(items.planDate).format('jYYYY/jMM/jDD')}</td>
                    <td>
                      {items.planTimeFrom} الی {items.planTimeTo}
                    </td>
                    <td>{items.totalCount}</td>
                    <td>{items.notAssignedCount}</td>
                    <td>{items.activeCount}</td>
                    <td>{items.startCount}</td>
                    <td>{items.finishCount}</td>
                    <td>{items.returnNotSeenCount}</td>
                    <td>{items.returnRejectCount}</td>
                    <td>{items.returnReAssignCount}</td>
                    <td>
                      <Link to={`/Factors/${items.planId}`}>
                        <img src={require('../../image/editDriver.svg')} alt="" />
                      </Link>
                    </td>
                    <td>
                      <Link to={`AssignedDrivers/${items.planId}`}>
                        <img src={require('../../image/delivery-truck.svg')} alt="" />
                      </Link>
                    </td>
                    <td>
                      <Link
                        to={`/EditFactorDrivers/${items.dispatchId}/driver=${this.props.match.params.driverId}/${
                          this.props.match.params.name
                        }`}
                      >
                        <img src={require('../../image/delivery-truck.svg')} alt="" />
                      </Link>
                    </td>
                  </tr>
                ))}

                <tr>
                  <td colSpan={3}>مجموع</td>
                  <td>{this.state.aggregation.totalCount}</td>
                  <td>
                    {this.state.aggregation.totalCount -
                      (this.state.aggregation.activeCount +
                        this.state.aggregation.startCount +
                        this.state.aggregation.finishCount +
                        this.state.aggregation.returnNotSeenCount +
                        this.state.aggregation.returnRejectCount +
                        this.state.aggregation.returnReAssignCount)}
                  </td>
                  <td>{this.state.aggregation.activeCount}</td>
                  <td>{this.state.aggregation.startCount}</td>
                  <td>{this.state.aggregation.finishCount}</td>
                  <td>{this.state.aggregation.returnNotSeenCount}</td>
                  <td>{this.state.aggregation.returnRejectCount}</td>
                  <td>{this.state.aggregation.returnReAssignCount}</td>
                  <td colSpan={4} />
                </tr>
              </tbody>
            </table>
            <div className="paginationWrapp">
              <Pagination
                current={this.state.current}
                onChange={this.onChangePage.bind(this)}
                total={this.state.length}
              />
              ,
            </div>
            {/*<div className="paginationWrapp">*/}
            {/*<Page defaultCurrent={1} total={DriversCount}*/}
            {/*onResultFetched={this.onResultFetched.bind(this)}*/}
            {/*url='report/dispatch/plan/byDriver'*/}
            {/*urlParams={urlParams}*/}
            {/*/>*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
    )
  }
}

export default PlanDrivers
